import { computed } from '@ember/object';
import Enum from '@square/dashboard-utilities/utils/enum';
import ExpirationDate from '@square/dashboard-data/models/squareup/simple-instrument-store/api/expiration-date';
import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
export const Brand = new Enum(['INVALID', 'UNKNOWN', 'VISA', 'MASTERCARD', 'AMEX', 'DISCOVER', 'DISCOVER_DINERS', 'INTERAC', 'JCB', 'UNION_PAY', 'SQUARE_GIFT_CARD_V2']);
export const BRAND_ICON = {
  UNKNOWN: 'other',
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  AMEX: 'amex',
  DISCOVER: 'discover',
  DISCOVER_DINERS: 'dinersclub',
  INTERAC: 'interac',
  JCB: 'jcb',
  UNION_PAY: 'unionpay',
  SQUARE_GIFT_CARD_V2: 'gift-card'
};
export const BalanceMoney = ProtoBaseModel.extend({
  amount: attr(Number),
  currency: attr(String)
});
export default ProtoBaseModel.extend({
  balanceMoney: attr(BalanceMoney),
  gan: attr(String),
  state: attr(String),
  type: attr(String),
  lastFour: attr(String),
  brand: attr(Brand),
  cardholderName: attr(String),
  bin: attr(String),
  expirationDate: attr(ExpirationDate),
  brandIconClass: computed('brand', function () {
    return `icon-tender-${BRAND_ICON[this.brand]}`;
  })
});